import { ITag } from "@/types/IBroadcastChannel";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface DropTakeState {
    disabled: boolean;
    loading: boolean;
    submit: boolean;
}

const initialState: DropTakeState = {
    disabled: false,
    loading: false,
    submit: false,
};
export const DropTake = createSlice({
  name: "drop_take_slice",
  initialState,
  reducers: {
    setDisabled: (state, action: PayloadAction<boolean>) => {
      state.disabled = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      state.disabled = action.payload ? true : false;
    },
    setDropTakeSubmit: (state, action: PayloadAction<boolean>) => {
      state.submit = action.payload
    }
  }
});

export const {
    setDisabled,
    setLoading,
    setDropTakeSubmit
} = DropTake.actions;

export default DropTake.reducer;
